import React, { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAdmins, clearAdmins, updateAdmin, deleteAdmin } from '../../redux/slices/AdminSlice';
import './AdminCSS/Details.css'; // Import the CSS file
import AdminUpdate from './adminupdate'; // Import Popup component


const AdminDetails = () => {
  const dispatch = useDispatch();
  const { admins, loading, error } = useSelector((state) => state.admins);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [formData, setFormData] = useState({ user_name: '', email: '' });
  

  useEffect(() => {
    dispatch(fetchAllAdmins());
    return () => {
      dispatch(clearAdmins());
    };
  }, [dispatch]);

  const handleUpdateClick = (admin) => {
    setSelectedAdmin(admin);
    setFormData({ user_name: admin.user_name, email: admin.email });
  };
  
  const handleUpdateSubmit = () => {
    if (selectedAdmin) {
      dispatch(updateAdmin({ adminId: selectedAdmin.admin_id, adminData: formData }));
      setSelectedAdmin(null);
    }
  };

  const handleDelete = (adminId) => {
    if (window.confirm('Are you sure you want to delete this admin?')) {
      dispatch(deleteAdmin(adminId));
    }
  };

  return (
    <div className="admins-page">
      {/* <h2 className="admin-title">Admins</h2> */}
      {loading && <p className="loading-text">Loading...</p>}
      {error && <p className="error-text">Error: Unable to fetch user admins. Please try again later.</p>}

      {!loading && !error && admins.length > 0 && (
        <table className="admins-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Operations</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((admin) => (
              <tr key={admin.admin_id}>
                <td>{admin.admin_id}</td>
                <td>{admin.user_name}</td>
                <td>{admin.email}</td>
                <td className="operations">
                  {/* <button className="view-btn" onClick={() => alert(`View ${admin.user_name}`)}>View</button> */}
                  <button className="update-btn" onClick={() => handleUpdateClick(admin)}>Update</button>
                  <button className="delete-btn" onClick={() => handleDelete(admin.admin_id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {!loading && !error && admins.length === 0 && <p className="empty-text">No user admins found.</p>}
      {selectedAdmin && (
        <AdminUpdate 
          formData={formData}
          setFormData={setFormData}
          handleUpdateSubmit={handleUpdateSubmit}
          setSelectedAdmin={setSelectedAdmin}
        />
      )}    
    </div>
  );
};

export default AdminDetails;

